"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "m11.7307 12.0743-1.9319-.5177-.5176 1.9319 1.9318.5176.5177-1.9318zm-.0432 3.1874 1.7321-1 1 1.7321-1.7321 1-1-1.7321z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1527 4H4.8467l2.2857 16h9.7346l2.2857-16zM7.4666 8.1972 7.1527 6h9.694l-.3957 2.77c-1.4318.3675-2.5913.2946-4.131-.2187-1.762-.5873-3.2155-.7054-4.8534-.3541zm.2836 1.9853L8.867 18h6.2654l1.0174-7.1216c-1.4822.2537-2.8417.1105-4.4623-.4297-1.4698-.49-2.593-.5786-3.9373-.2662z"
  })];
};

exports.default = _default;